import { useEffect, useState } from 'react';
import nodeAPI from '../../../service/ApiServiceNode';

export const campaignProjectNumber = project => project.generated_id || project.generatedId || project.id;

export default function useCampaignResultsAvailability(projects) {
    const provided = {};
    projects.forEach(project => {
        if (Object.prototype.hasOwnProperty.call(project, 'campaignResultsAvailable')) {
            provided[campaignProjectNumber(project)] = project.campaignResultsAvailable;
        }
    });
    const query = JSON.stringify([...new Set(projects.map(campaignProjectNumber)
        .filter(number => /^\d{4}-\d+$/.test(number) && !Object.prototype.hasOwnProperty.call(provided, number)))].sort());
    const [result, setResult] = useState({ query: '', availability: {} });
    useEffect(() => {
        let cancelled = false;
        const numbers = JSON.parse(query);
        if (!numbers.length) return undefined;
        async function load() {
            const availability = {};
            for (let start = 0; start < numbers.length; start += 100) {
                try {
                    const response = await nodeAPI.get('/project/campaign-results-availability', { params: { projectNumbers: numbers.slice(start, start + 100).join(',') } });
                    if (cancelled) return;
                    (response.data?.data?.projects || []).forEach(project => {
                        availability[project.projectNumber] = project.available === true;
                    });
                } catch {
                    // Do not label a project Available when its source cannot be checked.
                }
            }
            if (!cancelled) setResult({ query, availability });
        }
        load();
        return () => { cancelled = true; };
    }, [query]);
    return { ...(result.query === query ? result.availability : {}), ...provided };
}
